import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemoveTextstyle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRemoveTextstyle"><Path fillRule="evenodd" clipRule="evenodd" d="M2.90918 2.58862L21.4089 18.9119L20.0856 20.4115L11.8609 13.1544L10.8656 21.1164L8.88108 20.8683L10.0455 11.5527L1.58594 4.0883L2.90918 2.58862ZM7.9974 3.00008H19.9974V5.00008H12.8802L12.4906 8.11639L10.5061 7.86833L10.8646 5.00008H7.9974V3.00008Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRemoveTextstyle;
